import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './httpConfig/http'
import moment from 'moment'// 导入文件
import Meta from 'vue-meta'

Vue.prototype.$moment = moment // 赋值使用
Vue.prototype.$axios = axios // 全局注册，使用方法为:this.$axios
Vue.config.productionTip = false
Vue.use(Meta)
Vue.use(ElementUI)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
